import {
  createAppSelector,
  createStringArraySelector,
  orgUserSelectors,
  sectionUserSelectors,
  selectCurrentUserId,
  userSelectors,
} from "./base";

import { getUserFullName } from "utils/user-utils";

export const selectCurrentUser = createAppSelector(
  [selectCurrentUserId, userSelectors.selectEntities],
  (currentUserId, users) => (currentUserId ? (users[currentUserId] ?? null) : null),
);

export const selectUserNameById = createAppSelector([userSelectors.selectById], (user) =>
  getUserFullName(user),
);

export const selectAssessmentAIFeedbackStyle = createAppSelector(
  [selectCurrentUser],
  (currentUser) => currentUser?.assessment_ai_feedback_style ?? null,
);

/** User ids referenced by enrollment slices but not yet present in the users slice. */
export const selectMissingUserIds = createStringArraySelector(
  [sectionUserSelectors.selectUserIds, orgUserSelectors.selectUserIds, userSelectors.selectIds],
  (sectionUserIds, orgUserIds, loadedUserIds) => {
    const allUserIds = new Set([...sectionUserIds, ...orgUserIds]);
    const loadedUserIdSet = new Set(loadedUserIds);
    return [...allUserIds].filter((userId) => !loadedUserIdSet.has(userId));
  },
);

/** Stable string for effect deps — only changes when the set of missing user ids changes. */
export const selectMissingUserIdsKey = createAppSelector([selectMissingUserIds], (missingUserIds) =>
  missingUserIds.slice().sort().join(","),
);
